import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';

import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel.tsx';

import dibsCss from 'dibs-css';
import styles from './TradeBenefitsTierProgressionTile.module.css';

type Tier = 'silver' | 'gold' | 'platinum';

const TIER_STYLES: Record<Tier, { background: string; border: string }> = {
    silver: { background: styles.silver, border: styles.silverBorder },
    gold: { background: styles.gold, border: styles.goldBorder },
    platinum: { background: styles.platinum, border: styles.platinumBorder },
};

type Bullet = {
    id: string;
    content: ReactNode;
};

type Props = {
    tier: Tier;
    title: ReactNode;
    description: ReactNode;
    bullets: Bullet[];
};

const TradeBenefitsTierProgressionTile: FC<Props> = ({ tier, title, description, bullets }) => {
    const { background, border } = TIER_STYLES[tier];
    return (
        <div
            className={classnames(
                background,
                border,
                dibsCss.border,
                dibsCss.border2,
                dibsCss.borderSolid,
                dibsCss.roundedXsmall,
                dibsCss.pMedium
            )}
        >
            <div
                className={classnames(
                    dibsCss.flex,
                    dibsCss.flexWrap,
                    dibsCss.itemsBaseline,
                    dibsCss.gapXsmall,
                    dibsCss.mbSmall
                )}
            >
                <HeadingLevel>
                    {Heading => (
                        <Heading className={classnames(dibsCss.sassyFontHeaderLarge, dibsCss.m0)}>
                            {title}
                        </Heading>
                    )}
                </HeadingLevel>
                <span className={dibsCss.sassyFontBodySmall}>{description}</span>
            </div>
            <ul className={classnames(styles.bullets, dibsCss.m0, dibsCss.plMedium)}>
                {bullets.map(({ id, content }) => (
                    <li key={id} className={dibsCss.sassyFontBodyMediumHeavy}>
                        {content}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export { TradeBenefitsTierProgressionTile };
export type { Tier, Bullet };
